import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";

// i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false);
  const [ui, setui] = useState(false);
  const [app, setapp] = useState(false);
  const [email, setemail] = useState(false);
  const [ecommerce, setecommerce] = useState(false);
  const [crypto, setcrypto] = useState(false);
  const [project, setproject] = useState(false);
  const [task, settask] = useState(false);
  const [contact, setcontact] = useState(false);
  const [blog, setBlog] = useState(false);
  const [job, setJob] = useState(false);
  const [candidate, setCandidate] = useState(false);
  const [component, setcomponent] = useState(false);
  const [form, setform] = useState(false);
  const [table, settable] = useState(false);
  const [chart, setchart] = useState(false);
  const [icon, seticon] = useState(false);
  const [map, setmap] = useState(false);
  const [extra, setextra] = useState(false);
  const [invoice, setinvoice] = useState(false);
  const [auth, setauth] = useState(false);
  const [utility, setutility] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  const whatsappNumber = "919586363303";
  const whatsappMessage = encodeURIComponent(
    `Hello, I would like to : Buy, Rent, Sell the property \n`
  );

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  const handleLinkClick = () => {
    const menuToggleButton = document.querySelector('.header-item[data-toggle="collapse"]');
    if (menuToggleButton) {
      menuToggleButton.click();
    }
  };

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
              style={{ position: "relative", zIndex: 9999999 }}
            >
              <div
                style={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  whiteSpace: "nowrap",
                  WebkitOverflowScrolling: "touch",
                  maxWidth: "100%",
                }}
                className="custom-scroll-wrapper"
              >
                <ul
                  className="navbar-nav custom-scroll-ul"
                  style={{
                    display: "inline-flex",
                    minWidth: "max-content",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/" onClick={handleLinkClick}>
                      <i className="bx bx-building-house me-2"></i>
                      {props.t("Properties")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/postProperty" onClick={handleLinkClick}>
                      <i className="bx bx-map-alt me-2"></i>
                      {props.t("Post Property")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/web-stories" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("Web Stories")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/I-Want" onClick={handleLinkClick}>
                      <i className="bx bx-chat me-2"></i>
                      {props.t("I want")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/developers" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("Developers")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/Emi-Calculator" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("EMI Calculator")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/blog" onClick={handleLinkClick}>
                      <i className="bx bx-pencil me-2"></i>
                      {props.t("Blog")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/dashboard" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("Ask Ai")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/finance-quest" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("AI In Finance Planning")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" title="Buy Sell Rent Property Vadodara" to="/Buyers-Sellers-Owners-Tenants-Daily-Property-Updates-Vadodara" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("Updates")}
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/interior-design" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("AI in Interior Design")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" to="/ai-products" onClick={handleLinkClick}>
                      <i className="bx bx-brain me-2"></i>
                      {props.t("Ai Products")}
                    </Link>
                  </li> */}
                  <li className="nav-item">
                    <Link className="nav-link dropdown-toggle arrow-none" title="Contact" to="/contact" onClick={handleLinkClick}>
                      <i className="bx bx-phone me-2"></i>
                      {props.t("Contact Us")}
                    </Link>
                  </li>
                  {isMobile && (
                    <li className="nav-item">
                      <Link className="nav-link dropdown-toggle arrow-none" to="/login" onClick={handleLinkClick}>
                        <i className="bx bx-log-in me-2"></i>
                        {props.t("Login")}
                      </Link>
                    </li>
                  )}
                </ul>
              </div>

            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func.isRequired,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);